import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		lstCv2: [],
		cv2: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		getSearch(state){
			return state.search
		},
		getCv2(state){
			state.cv2.cv2titulo = state.cv2.cv2titulo.toUpperCase()
			return state.cv2
		},
		getCv2titulo(state){
			return state.cv2.cv2titulo
		},
		getItemsPerPage(state){
			return state.itemsPerPage
		},
		getUpdate(state){
			return state.update
		},
		getHasNext(state){
			return state.hasNext
		},
		getLstcv2(state){
			return state.lstCv2
		},
	},
	mutations: {
		set(state, cv2){
			state.cv2 = cv2
			if (cv2)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cv2 = null
		},
		setParamsDataTable(state, payload){
			state.lstCv2 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLstCv2(state, lstCv2){
			state.lstCv2 = lstCv2
		},
		setItemsPerPage(state, itemsPerPage){
			state.itemsPerPage = itemsPerPage
		},
		setSearch(state, search){
			state.search = search
		},
		setHasNext(state, hasNext){
			state.hasNext = hasNext
		},
		setLoading(state, loading){
			state.loading = loading
		},
		setCv2(state, cv2){
			state.cv2 = cv2
		},
	},
	actions: {
		initForm({ commit }){
			commit("initForm")
		},
		async get({ dispatch }, cv2titulo){
			return await this._vm.$axios.get(`/PaymentCondition/Title/Find/${cv2titulo}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find({ dispatch, commit }, cv2titulo){
			commit("setLoading", true)
			commit("initForm")
			await dispatch("get", cv2titulo)
			.then(cv2 => {
				commit("set", cv2)
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			commit("setLoading", false)
		},
		save({ dispatch, getters }){
			if (getters.getUpdate)
				return dispatch("update")
			return dispatch("insert")
		},
		async insert({ dispatch, commit, getters }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/PaymentCondition/Title/Insert", getters.getCv2 )
			.then(response => {
				let res = Utils.ValidateAxiosResponse(response.data);
				commit("setCv2", null)
				return res
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async update({ dispatch, commit, getters  }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/PaymentCondition/Title/Update", getters.getCv2 )
			.then(response => {
				let res = Utils.ValidateAxiosResponse(response.data);
				commit("setCv2", null)
				return res
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async delete({ dispatch, getters }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.delete(`/PaymentCondition/Title/Delete/${getters.getCv2titulo}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async findAll({ commit, dispatch }){
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios.get("/PaymentCondition/Title/FindAll")
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			}).catch(error => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			})
			commit("setLoading", false)
			return payload
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }){
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/PaymentCondition/Title/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				commit("setLstCv2", payload.items)
				commit("setItemsPerPage", payload.limit)
				commit("setHasNext", payload.hasNext)
			})
			.catch((error) => {
				commit("setLstCv2", [])
				commit("setSearch", "")
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			commit("setLoading", false)
		}
	}
}